import React from "react";
import { Button } from "../ui/button";
import { Icon } from "@iconify/react";

export default function SendWhatsapp({
  phone = "",
  header = "",
  data = {},
  footer = "",
  buttonText = "Send Whatsapp",
  buttonIcon = "mdi:whatsapp",
  buttonSize = "sm",
  buttonVariant = "outline",
  className = "",
}) {
  const buildMessage = () => {
    let msg = "";
    if (header) msg += header + "\n\n";

    Object.keys(data).forEach((key) => {
      msg += `${key}: ${data[key]}\n`;
    });

    if (footer) msg += `\n${footer}`;
    return msg;
  };

  const sendWhatsapp = () => {
    const cleaned = (phone || "").toString().replace(/[^0-9]/g, "");
    if (!cleaned) {
      alert("Invalid phone number!");
      return;
    }
    const finalMessage = encodeURIComponent(buildMessage());
    const url = `https://api.whatsapp.com/send?phone=${cleaned}&text=${finalMessage}`;
    window.open(url, "_blank"); 
  };

  return (
    <Button
      size={buttonSize}
      variant={buttonVariant}
      onClick={sendWhatsapp}
      className={className}
    >
      <Icon icon={buttonIcon} width={16} className="transition-colors duration-200" />
      <span className="text-xs">{buttonText}</span>
    </Button>
  );
}
